/**
 * アウトライン
 */

jQuery( function ($) {
	document.body.addEventListener('mousedown', function() {
		document.body.classList.add('no-outline');
	});
	
	document.body.addEventListener('keydown', function(event) {
		if (event.key === 'Tab') {
			document.body.classList.remove('no-outline');
		}
	});	
} );